module.exports = __webpack_public_path__ + "img/3ab9714156694080b72d2c5ea4e17a1e.bb2774aa.jpg";